import React, { useRef } from "react";

import { FormikProps } from "formik";
import { t } from "i18next";

import { CompanyForm } from "@/components/organisms";

import { TOnboardingCompanyValues } from "@/types";

import { OnboardingStepCard } from "../components/OnboardingStepCard";

interface ICompanyStepProps {
	initialValues: TOnboardingCompanyValues;
	onBack: () => void;
	onSkip: () => void;
	onNext: (values: TOnboardingCompanyValues) => void;
	isSubmitting: boolean;
}

/**
 * Last step: "Finish" (or "Skip") here is the final submit, hence
 * `isSubmitting`. The fields are `CompanyForm`'s (shared with the
 * companies page); the card's "Finish" button submits it through its ref.
 */
export const CompanyStep: React.FC<ICompanyStepProps> = ({
	initialValues,
	onBack,
	onSkip,
	onNext,
	isSubmitting,
}) => {
	const formRef = useRef<FormikProps<TOnboardingCompanyValues>>(null);

	return (
		<OnboardingStepCard
			step="company"
			title={t("onboarding.steps.company.title")}
			intro={t("onboarding.steps.company.intro")}
			onBack={onBack}
			onSkip={onSkip}
			onNext={() => formRef.current?.submitForm()}
			isSubmitting={isSubmitting}
			nextLabel={t("onboarding.finish")}
		>
			<CompanyForm
				innerRef={formRef}
				initialValues={initialValues}
				onSubmit={onNext}
				logoInputId="onboarding-company-logo"
			/>
		</OnboardingStepCard>
	);
};
